import $ from 'jquery';
import jump from 'jump.js';
import foundation from '../global/foundation'
import lozad from 'lozad'

window.addEventListener('load', function() {

  var rea_list = document.querySelector('.js-realisations-list');

  if(!rea_list)
    return;

  window.paged = 2;
  var maxnumpages = document.querySelector('.js-list-realisation-item').getAttribute('data-maxnumpages');
  var selects = document.querySelectorAll('select');
  var loadMoreButton = document.querySelector('.js-load-more-realisations');
  var applicationSlug = 'projet';
  var collectionSlug  = 'collection';
  var typeSlug        = 'type';
  var cibleSlug       = 'cible';
  var departementSlug = 'departement';
  var currentApplication = getUrlParameter(applicationSlug) ? getUrlParameter(applicationSlug) 
    : document.querySelector('select#select_application').value;
  var currentCollection  = getUrlParameter(collectionSlug)  ? getUrlParameter(collectionSlug)  
    : document.querySelector('select#select_collection').value;
  var currentType        = getUrlParameter(typeSlug)        ? getUrlParameter(typeSlug)        
    : document.querySelector('select#select_type').value;
  var currentCible       = getUrlParameter(cibleSlug)       ? getUrlParameter(cibleSlug)       
    : document.querySelector('select#select_cible').value;
  var currentDepartement = getUrlParameter(departementSlug) ? getUrlParameter(departementSlug) 
    : document.querySelector('select#select_departement').value;
  const observer = lozad(); 

  // Load Realisations on Page Init
  loadRealisations();

  // On filters change, empty List & load a new List
  Array.prototype.forEach.call(selects, function(select, i){
    select.addEventListener('change', function(){

      if(this.id == 'select_application')
        currentApplication = this.value;
      if(this.id == 'select_collection')
        currentCollection = this.value;
      if(this.id == 'select_type')
        currentType = this.value;
      if(this.id == 'select_cible')
        currentCible = this.value;
      if(this.id == 'select_departement')
        currentDepartement = this.value;

      rea_list.classList.add('loading');
      jump('.productions', {
        duration: 650,
        offset: -150
      })
      rea_list.innerHTML = '';
      window.paged = 1;
      loadMoreButton.style.display = "none";
      loadRealisations();
    });
  });

  // On Load More Click, Show n+1 Page and Load hidden n+2 Page
  loadMoreButton.addEventListener('click', function(){

    // Disabled during ajax load
    if(loadMoreButton.classList.contains('disabled'))
      return;

    window.paged++;
    loadRealisations();
  });

  // Show previous Page & Load hidden next Page with filters
  function loadRealisations(){

    // console.log(window.paged);
    rewriteURL(); 

    // Display previous Pages
    var realisationItems = document.querySelectorAll('.js-list-realisation-item');
    Array.prototype.forEach.call(realisationItems, function(el){
      el.classList.remove('visually-hidden');
    });

    // Disable loadMoreButton during ajax load
    loadMoreButton.classList.add('disabled');
    // Hide loadMoreButton & break function when there's no more Page to load
    if(window.paged > maxnumpages){
      loadMoreButton.style.display = 'none';
      return;
    }

    // Ajax Post
    $.ajax({
      cache: true,
      url: ajax_js.ajaxurl,
      type: 'get',
      data: {
        action: 'load_realisations',
        paged: window.paged,
        application: currentApplication,
        collection:  currentCollection,
        type:        currentType,
        cible:       currentCible,
        departement: currentDepartement,
      },
      success: function(html) {

        if(html){
        
          var htmlElement = document.createElement( 'html' );
          htmlElement.innerHTML = html;

          // Add page results to list
          rea_list.classList.remove('loading');
          rea_list.innerHTML += html;

          if(htmlElement.getElementsByClassName('js-no-result').length == 0){

            $('.production-detail.visually-hidden').foundation();
  
            // On 1st page, set maxnumpage and load an hidden 2nd page
            if(window.paged == 1){
              maxnumpages = document.querySelector('.js-list-realisation-item').getAttribute('data-maxnumpages');
              window.paged++;
              loadRealisations();
            }
  
            if(window.paged <= maxnumpages){
              loadMoreButton.style.display = 'inline-flex';
            }
  
            // Enable loadMoreButton after ajax load
            loadMoreButton.classList.remove('disabled');

          }

          // Lazy Load Observer
          observer.observe();

        }
      }
    });
  }

  // Rewrite current page URL according to current filters
  function rewriteURL() {

    var parametersArray = [];
    var parametersSlug = location.protocol + '//' + location.host + location.pathname;

    if(currentApplication != '' && currentApplication != 'all')
      parametersArray.push({
        'slug' : applicationSlug,
        'filter' : currentApplication
      });
    if(currentCollection != '' && currentCollection != 'all')
      parametersArray.push({
        'slug' : collectionSlug,
        'filter' : currentCollection
      });
    if(currentType != '' && currentType != 'all')
      parametersArray.push({
        'slug' : typeSlug,
        'filter' : currentType
      });
    if(currentCible != '' && currentCible != 'all')
      parametersArray.push({
        'slug' : cibleSlug,
        'filter' : currentCible
      });
    if(currentDepartement != '' && currentDepartement != 'all')
      parametersArray.push({
        'slug' : departementSlug,
        'filter' : currentDepartement
      });

    for (let index = 0; index < parametersArray.length; index++) {
      if(index == 0)
        parametersSlug += '?';
      else
        parametersSlug += '&';

      parametersSlug += parametersArray[index]['slug'] + "=" + parametersArray[index]['filter'];
    }

    window.history.pushState("", "", parametersSlug);
  }

  // Get parameter value from an URL parameter key
  function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam)
        return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }

});
